import { request, type PagedList } from './request';
import { buildListParams } from './params';
import type { BannerDto, PartnerDto } from './types';

/** 轮播位置类型（对齐小程序 BannerLocationTypeEnum） */
export const BANNER_LOCATION_HOMEPAGE_TOP = 1;

/** 轮播广告列表（/content/bannerList，公开接口） */
export function fetchBannerList(locationType: number = BANNER_LOCATION_HOMEPAGE_TOP): Promise<{ list: BannerDto[] }> {
  return request('/content/bannerList', { locationType });
}

/** 合作伙伴列表（/content/userGetOthPartnerList，公开接口） */
export function fetchPartnerList(pageIndex = 1, pageSize = 100): Promise<PagedList<PartnerDto>> {
  return request(
    '/content/userGetOthPartnerList',
    buildListParams({ pageIndex, pageSize, state: 1 }),
  );
}

/** 提交意见反馈/合作咨询（/content/submitFeedbackInfo，需登录） */
export function submitFeedbackInfo(data: {
  feedback: string;
  name?: string;
  imgList?: string[];
}): Promise<unknown> {
  return request('/content/submitFeedbackInfo', {
    name: data.name ?? '',
    feedback: data.feedback,
    imgList: data.imgList ?? [],
  });
}
